import React from "react";
import { DebitListForCreditCard } from "@icoach/batchPayment/component";
import { useBatchPaymentContext } from "@icoach/batchPayment/component/BatchPaymentContext";


const RentCabinetBatchPaymentCurrentDebitList = () => {
    const { searchParams, batchPaymentLists, dialogRef, getBatchPayments } = useBatchPaymentContext();
    const { creditItems } = batchPaymentLists || {};

    return <DebitListForCreditCard list={creditItems} searchParams={searchParams} dialogRef={dialogRef} refresh={getBatchPayments} />
};

export default RentCabinetBatchPaymentCurrentDebitList;
